import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaFilePdf, FaFileImage, FaFileArchive, FaTasks, FaCalendarAlt, FaComments, FaFolderOpen } from "react-icons/fa";
import { Link } from "react-router-dom";

const Customerdashboard = () => {
  const styles = {
    container: {
      backgroundColor: "#f8f9fa",
      padding: "2rem",
      borderRadius: "12px",
      boxShadow: "0 4px 16px rgba(0,0,0,0.05)",
      marginTop: "3rem"
    },
    heading: {
      fontWeight: "700",
      textAlign: "center",
      color: "#212529",
      marginBottom: "2rem"
    },
    card: {
      borderRadius: "10px",
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.05)"
    },
    cardHeaderGreen: {
      backgroundColor: "#198754", // green
      color: "#fff",
      fontWeight: "600",
      padding: "0.75rem 1rem",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem"
    },
    cardHeaderOrange: {
      backgroundColor: "#fd7e14", // orange
      color: "#fff",
      fontWeight: "600",
      padding: "0.75rem 1rem",
      display: "flex",
      alignItems: "center",
      gap: "0.5rem"
    },
    cardBody: {
      padding: "1rem"
    },
    fileItem: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0.75rem 1rem",
      borderBottom: "1px solid #dee2e6"
    },
    commentContainer: {
      display: "flex",
      alignItems: "center",
      marginBottom: "1rem"
    },
    avatar: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      marginRight: "1rem",
      border: "2px solid #dee2e6"
    }
  };

  return (
    <div className="container" style={styles.container}>
      <h2 style={styles.heading}>Project Management Dashboard</h2>

      <div className="row g-4">
        {/* List of Projects */}
        <div className="col-lg-4">
          <div style={styles.card} className="card h-100">
            <div style={styles.cardHeaderGreen} className="card-header">
              <FaTasks /> List of Projects
            </div>
            <div className="card-body p-0">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Project</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Website Redesign</td>
                    <td><span className="badge bg-success">Ongoing</span></td>
                  </tr>
                  <tr>
                    <td>Mobile App Dev</td>
                    <td><span className="badge bg-warning text-dark">On Hold</span></td>
                  </tr>
                  <tr>
                    <td>CRM Implementation</td>
                    <td><span className="badge bg-success">Ongoing</span></td>
                  </tr>
                  <tr>
                    <td>SEO Optimization</td>
                    <td><span className="badge bg-secondary">Completed</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className="col-lg-8">
          <div style={styles.card} className="card h-100">
            <div style={styles.cardHeaderOrange} className="card-header">
              <FaCalendarAlt /> Timeline
            </div>
            <div className="card-body p-0">
              <table className="table table-bordered align-middle text-center mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Project</th>
                    <th>Apr 1</th>
                    <th>Apr 3</th>
                    <th>Apr 22</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Website Redesign</td>
                    <td><span className="badge bg-info text-dark">Website Redesign</span></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Mobile App Dev</td>
                    <td></td>
                    <td><span className="badge bg-warning text-dark">On Hold</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>CRM Implementation</td>
                    <td></td>
                    <td><span className="badge bg-info text-dark">CRM Implementation</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>SEO Optimization</td>
                    <td></td>
                    <td></td>
                    <td><span className="badge bg-secondary">SEO Optimization</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Files & Deliverables */}
        <div className="col-lg-6">
          <div style={styles.card} className="card h-100">
            <div style={styles.cardHeaderOrange} className="card-header">
              <FaFolderOpen /> Files & Deliverables
            </div>
            <div className="card-body">
              <div style={styles.fileItem}>
                <span><FaFilePdf className="me-2 text-danger" /> Project_Plan.pdf</span>
                <Link href="#" download className="btn btn-sm btn-outline-warning">Download</Link>
              </div>
              <div style={styles.fileItem}>
                <span><FaFileImage className="me-2 text-info" /> Design_Mockup.png</span>
                <Link href="#" download className="btn btn-sm btn-outline-warning">Download</Link>
              </div>
              <div style={{ ...styles.fileItem, borderBottom: "none" }}>
                <span><FaFileArchive className="me-2 text-warning" /> App_Source_Code.zip</span>
                <Link href="#" download className="btn btn-sm btn-outline-warning">Download</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Developer Comments */}
        <div className="col-lg-6">
          <div style={styles.card} className="card h-100">
            <div style={styles.cardHeaderGreen} className="card-header">
              <FaComments /> Developer Comments
            </div>
            <div style={styles.cardBody}>
              <div style={styles.commentContainer}>
                <img
                  src="https://via.placeholder.com/50"
                  alt="John Doe"
                  style={styles.avatar}
                />
                <div>
                  <strong>John Doe</strong>
                  <div className="text-muted small">Apr 15</div>
                </div>
              </div>
              <p className="text-dark">
                API integration is in progress. Expected to be completed by the end of the week. Please review backend sync logic.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customerdashboard;
